export default __webpack_public_path__ + "static/media/tri.ca318db3.png";